<template>

  <div class="menu-title">
    <p>Small Plates</p>
  </div>


  <div class="smallplates-container-1">

    <div class="smallplates-grid-1">
      <div>
        <img class="menu-pic" src="../assets/DumplingPanFried.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie Dumpling (3) Pan-Fried</p>
        <!-- <p>5.99</p> -->
      </div>
    </div>

    <div class="smallplates-grid-2">
      <div>
        <img class="menu-pic" src="../assets/DumplingPanFried.jpg">
      </div>
      <div class="menu-text">
        <p>Chicken Tender & Fries</p>
        <!-- <p>8.99</p> -->
      </div>
    </div>

    <div class="smallplates-grid-3">
      <div>
        <img class="menu-pic" src="../assets/DumplingPanFried.jpg">
      </div>
      <div class="menu-text">
        <p>Shrimp Tempura (3) & Fries</p>
        <!-- <p>8.99</p> -->
      </div>
    </div>

  </div>

  <div class="smallplates-container-2">

    <div class="smallplates-grid-4">
      <div>
        <img class="menu-pic" src="../assets/DumplingPanFried.jpg">
      </div>
      <div class="menu-text">
        <p>Steamed Veggie</p>
        <p>(Carrot, Potato, Yam)</p>
        <!-- <p>5.99</p> -->
      </div>
    </div>

  </div>

</template>


<script>

  export default {
    name: 'SmallPlatesBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 3vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -1vw;
    color: darkblue;
  }


  .smallplates-container-1, .smallplates-container-2 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 5vw;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    color: darkblue;
  }


  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

}
  
</style>